import React from 'react'

type WifiProps = {
  className?: string
}

const _Wifi = (props: WifiProps) => (
  <svg width="24" height="17" viewBox="0 0 24 17" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.65464 9.5001C4.35464 9.5001 4.05464 9.4001 3.85464 9.1001C3.45464 8.7001 3.55464 8.0001 3.95464 7.7001C8.45464 4.0001 14.8546 4.0001 19.3546 7.7001C19.7546 8.1001 19.8546 8.7001 19.4546 9.1001C19.0546 9.5001 18.4546 9.6001 18.0546 9.2001C14.3546 6.1001 8.95464 6.1001 5.25464 9.2001C5.15464 9.5001 4.85464 9.5001 4.65464 9.5001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.05464 6.0001C0.75464 6.0001 0.45464 5.9001 0.25464 5.7001C-0.14536 5.3001 -0.0453602 4.7001 0.35464 4.3001C6.75464 -1.2999 16.4546 -1.2999 22.8546 4.3001C23.2546 4.7001 23.3546 5.3001 22.9546 5.7001C22.5546 6.1001 21.9546 6.2001 21.5546 5.8001C15.8546 0.800097 7.35464 0.800097 1.75464 5.8001C1.55464 5.9001 1.35464 6.0001 1.05464 6.0001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1546 13.1001C14.9546 13.1001 14.7546 13.0001 14.5546 12.9001C12.8546 11.7001 10.4546 11.7001 8.75464 12.9001C8.25464 13.2001 7.65464 13.1001 7.35464 12.7001C7.05464 12.2001 7.15464 11.6001 7.55464 11.3001C9.95464 9.6001 13.2546 9.6001 15.6546 11.3001C16.1546 11.6001 16.2546 12.2001 15.8546 12.7001C15.7546 13.0001 15.4546 13.1001 15.1546 13.1001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6546 17.0001C11.5546 17.0001 11.3546 17.0001 11.2546 16.9001C11.1546 16.9001 11.0546 16.8001 10.9546 16.7001C10.7546 16.5001 10.6546 16.3001 10.6546 16.0001C10.6546 15.9001 10.6546 15.7001 10.7546 15.6001C10.8546 15.5001 10.8546 15.4001 10.9546 15.3001C11.3546 14.9001 11.9546 14.9001 12.3546 15.3001C12.5546 15.5001 12.6546 15.8001 12.6546 16.0001C12.6546 16.3001 12.5546 16.5001 12.3546 16.7001C12.1546 16.9001 11.9546 17.0001 11.6546 17.0001Z"
      fill="currentColor"
    />
  </svg>
)

export default React.memo(_Wifi)
